import { createApp } from "vue";
// import VueGtag from "vue-gtag";
import App from "./App.vue";

// Click outside directive
const clickOutside = {
  beforeMount: (el, binding) => {
    el.clickOutsideEvent = (event) => {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        binding.value();
      }
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted: (el) => {
    document.removeEventListener("click", el.clickOutsideEvent);
  },
};

// Router
import router from "@/router";

// Styles
import "@/assets/index.css";

// GTM

// Meta
import { createMetaManager } from "vue-meta";

const app = createApp(App);

app.use(router);

app.directive("click-outside", clickOutside);
app.use(createMetaManager());
// app.use(VueGtag, {
//   config: { id: 'GTM-WN4WG24' },
// });

app.mount("#app");
